import * as yup from 'yup';

// No direct type import; we expose a Yup schema type

export const validation: yup.AnyObjectSchema = yup
  .object()
  .shape({
    // Toggle field
    useGitOps: yup.boolean().required(),

    // Helm atomic option applies to both modes
    atomic: yup.boolean().required('Please select a rollback strategy.'),

    // Manual mode fields - required when useGitOps is false
    version: yup.string().when('useGitOps', {
      is: false,
      then: (schema) =>
        schema.required('Please select a version to upgrade to.'),
      otherwise: (schema) => schema,
    }),
    repo: yup.string(),
    registryId: yup.number(),
    chart: yup.string().when('useGitOps', {
      is: false,
      then: (schema) => schema.required('Please select a chart.'),
      otherwise: (schema) => schema,
    }),
    values: yup.string(),

    SourceId: yup.number().when('useGitOps', {
      is: true,
      then: yup.number().required('Source is required'),
      otherwise: yup.number().optional(),
    }),
    RepositoryURL: yup.string(),
    RepositoryURLValid: yup.boolean(),
    HelmChartPath: yup.string(),
    HelmValuesFiles: yup
      .array(yup.string().required('Path is required'))
      .default([]),
    RepositoryReferenceName: yup.string(),

    // Auto update fields (only relevant in Git mode)
    AutoUpdate: yup.object().shape({
      RepositoryAutomaticUpdates: yup.boolean().default(false),
      ForcePullImage: yup.boolean().default(false),
      RepositoryAutomaticUpdatesForce: yup.boolean().default(false),
    }),
    webhookId: yup.string(),
  })
  .test(
    'either-registry-or-repo',
    'Please select a registry or repository.',
    function validateRegistryOrRepo(values) {
      // Only validate registry/repo when in manual mode
      if (values.useGitOps) {
        return true;
      }

      if (!values.registryId && !values.repo) {
        return this.createError({
          path: 'registryId',
          message: 'Please select a registry or repository.',
        });
      }
      return true;
    }
  );
